const navigationData = [
  {
    label: "Gourmet Cheese",
    category: "Cheese",
    columns: [
      { title: "By Style", links: ["Aged", "Soft-ripened", "Blue", "Smoked"] },
      { title: "By Milk", links: ["Cow", "Goat", "Sheep", "Mixed milk"] },
      { title: "Discover", links: ["Award winning", "Hand cut", "Cheese boards"] },
    ],
  },
  {
    label: "Meats & Charcuterie",
    category: "Charcuterie",
    columns: [
      { title: "Cured Meats", links: ["Prosciutto", "Salami", "Bresaola"] },
      { title: "Prepared", links: ["Pâté", "Terrines", "Board favorites"] },
    ],
  },
  {
    label: "Seafood & Caviar",
    category: "Seafood",
    columns: [
      { title: "Seafood", links: ["Caviar", "Smoked fish", "Prepared seafood"] },
      { title: "Entertain", links: ["Tasting sets", "Pairings", "Celebrations"] },
    ],
  },
  {
    label: "Pantry & Bakery",
    category: "Pantry",
    columns: [
      { title: "Pantry", links: ["Sauces", "Oils & vinegars", "Pasta", "Preserves"] },
      { title: "Bakery", links: ["Crackers", "Biscuits", "Chocolate", "Snacks"] },
    ],
  },
  {
    label: "Gifts & Experiences",
    category: "Gifts",
    columns: [
      { title: "Shop by Occasion", links: ["Thank you", "Celebrations", "Host gifts"] },
      { title: "Shop by Budget", links: ["Under $50", "Under $100", "Premium"] },
    ],
  },
];

export default navigationData;
